'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jsxRuntime = require('react/jsx-runtime');
var styled = require('@emotion/styled');
var dayjs = require('dayjs');
var coreRenderer = require('@tempi/core-renderer');
var constants = require('../constants.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var dayjs__default = /*#__PURE__*/_interopDefaultLegacy(dayjs);

const ArticleCard = ({ article, layout = "list" }) => {
  const { device } = coreRenderer.useStore();
  const isMobile = device === "mobile";
  if (!article)
    return null;
  const { name, description, extraInfo, articleInfo, canonical } = article || {};
  return /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, {
    layout: isMobile ? "grid" : layout,
    href: canonical,
    target: "_blank",
    rel: "noreferrer",
    children: [
      /* @__PURE__ */ jsxRuntime.jsx("div", {
        children: /* @__PURE__ */ jsxRuntime.jsx(Thumbnail, {
          layout,
          children: /* @__PURE__ */ jsxRuntime.jsx(ThumbnailContent, {
            children: /* @__PURE__ */ jsxRuntime.jsx("img", {
              src: (extraInfo == null ? void 0 : extraInfo.metaImage) || constants.DEFAULT_ARTICLE_THUMBNAIL,
              width: "100%",
              height: "100%",
              style: {
                objectFit: "cover"
              },
              alt: name
            })
          })
        })
      }),
      /* @__PURE__ */ jsxRuntime.jsxs("div", {
        children: [
          /* @__PURE__ */ jsxRuntime.jsx(Title, {
            children: name
          }),
          /* @__PURE__ */ jsxRuntime.jsx(Description, {
            children: description
          }),
          /* @__PURE__ */ jsxRuntime.jsx(AuthorName, {
            children: articleInfo == null ? void 0 : articleInfo.authorName
          }),
          /* @__PURE__ */ jsxRuntime.jsx(PublishedAt, {
            children: dayjs__default["default"].unix(articleInfo == null ? void 0 : articleInfo.publishedAt).format("DD/MM/YYYY")
          })
        ]
      })
    ]
  });
};
const Wrapper = styled__default["default"].a(
  ({ layout }) => layout === "grid" ? `
    display: flex;
    flex-direction: column;
    gap: 16px;
    ` : `
    display: grid;
    grid-template-columns: 1fr 2fr;
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    `
);
const Title = styled__default["default"].div`
  font-weight: bold;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  margin-bottom: 1em;
  line-height: 1.5;
`;
const Description = styled__default["default"].div`
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  margin-bottom: 0.5em;
  line-height: 1.5;
`;
const Thumbnail = styled__default["default"].div(
  ({ layout }) => `
position: relative;
padding-bottom: 67%;
overflow: hidden;
border-radius: 8px;
`
);
const AuthorName = styled__default["default"].div`
  margin-bottom: 0.5em;
`;
const PublishedAt = styled__default["default"].div`
  margin-bottom: 0.5em;
`;
const ThumbnailContent = styled__default["default"].div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

exports.ArticleCard = ArticleCard;
